module.exports = __webpack_public_path__ + "static/media/fa-solid-900.6ed5e3bc.svg";